import { Trans, useLingui } from "@lingui/react/macro";

import { AButton } from "~/ui/base/AButton";
import { createDraggableSheet } from "~/ui/base/DraggableSheet";
import { Theme, useTheme } from "~/ui/provider/ThemeProvider.tsx";

export const ThemeSheet = createDraggableSheet(({ close, titleId }) => {
  const { setTheme } = useTheme();
  const { t } = useLingui();

  const options = [
    {
      description: t`밝은 배경의 화면을 유지합니다.`,
      label: t`밝은 모드`,
      value: Theme.Light,
    },
    {
      description: t`어두운 배경의 화면을 유지합니다.`,
      label: t`어두운 모드`,
      value: Theme.Dark,
    },
    {
      description: t`기기나 시스템의 다크모드 설정에 맞춰 바뀝니다.`,
      label: t`시스템 설정`,
      value: Theme.System,
    },
  ];

  return (
    <div className="p-6 pt-2.5">
      <h1
        className="pb-3 text-lg font-semibold text-zinc-800 dark:text-zinc-100"
        id={titleId}
      >
        <Trans>다크모드 설정</Trans>
      </h1>
      {options.map(({ description, label, value }) => (
        <AButton
          className="w-full rounded-xl py-3 text-start duration-150 active:scale-[98%] disabled:opacity-80"
          key={value}
          onClick={() => {
            setTheme(value);
            close();
            return Promise.resolve();
          }}
        >
          <p className="text-zinc-800 dark:text-zinc-100">{label}</p>
          <p className="mt-0.5 text-sm text-zinc-500 dark:text-zinc-400">
            {description}
          </p>
        </AButton>
      ))}
    </div>
  );
});
